export default __webpack_public_path__ + "static/media/no-data.72d08f8e.svg";